import React, {Component} from 'react';
import _, {result} from 'lodash';
import {connect} from 'react-redux';
import {ListEpocOrganizations} from 'go/pages/home/listEpocOrganizations';
import MyWorkCard from 'go/pages/home/MyWorkCard';
import MyGrantsCard from 'go/pages/home/MyGrantsCard';
import {Toggle} from 'componentLibrary';
import {
  STATUS_PENDING_SUBMISSION,
  NUM_ACTIONS_TO_SHOW,
} from 'app-ui-componentlibrary/dist/common/constants';

import REST from 'go/requests/rest';
import ApplyNewGrantCard from './ApplyNewGrantCard';
import ApplyNewGrantCardSection from './ApplyNewGrantCardSection';
import PermissionsUtility from 'go/security/permissionsUtility';
import {
  hasAuthorizationToViewSubapplication,
  canViewAndContinueSubapplication,
  extractOrgIdsFromPermissions,
  extractSubOrgIdsFromPermissions,
} from 'go/security/permissions';
import {getActionVal} from 'common/utils';
import {forceJsonResponse} from 'common/utils';
import {FLUX} from 'app-ui-componentlibrary/dist/common/constants';
export class RecipientActions extends Component {
  state = {
    entityData: null,
    grants: [],
    applications: [],
    thingsToDo: {total: 0, items: []},
    saveForLater: {total: 0, items: []},
    saveForLaterEntities: [],
  };

  componentDidMount() {
    const {token} = this.props;
    const perms = this.props.permissions;
    const permissionData = new PermissionsUtility(token);
    const {permissions} = permissionData;
    let orgPrograms = [];
    let organizationId = '';

    const orgIds = extractOrgIdsFromPermissions(this.props.permissions);
    const orgId = orgIds[0];
    let subOrgIds = extractSubOrgIdsFromPermissions(this.props.permissions);
    if (_.isEmpty(subOrgIds)) subOrgIds = orgIds;

    permissions.sort().forEach((org) => {
      const [entityId, orgId] = org.split(':');
      const [orgOnlyId, prgId, subOrgId] = orgId.split('_');
      if (entityId == 1 || entityId == 5) {
        organizationId = orgOnlyId;
        if (subOrgId != null && !orgPrograms.includes(subOrgId)) {
          orgPrograms.push(subOrgId);
        } else if (subOrgId == null && !orgPrograms.includes(orgOnlyId)) {
          orgPrograms.push(orgId);
        }
      }
    });

    orgPrograms = _.uniq(orgPrograms);
    this.setState({orgPrograms});
    this.setState({organizationId});
    this.setState({orgIds});
    this.setState({subOrgIds});

    if (_.includes(this.props.toggles, 'disasterSiteNav')) {
      this.retrieveUserThingsToDo(token, orgId, orgIds, subOrgIds);
      this.retrieveUserSavedForLater(token, orgId);
    }
    return this.getUserOrgs().then(() => {
      return this.getOrganizations();
    });
  }

  retrieveUserThingsToDo = async (
    token,
    organizationId,
    organizationIds,
    subOrganizationIds,
    limit = 10,
    offset = 0,
    sort = 'dueDate',
    order = 'DESC'
  ) => {
    let toDoList = this.state.thingsToDo;
    REST.search
      .getRecipientToDoList(token, {
        organizationId: organizationId,
        organizationIds: organizationIds,
        subOrganizationIds: subOrganizationIds,
        limit: limit,
        offset: offset,
        sort: sort,
        order: order,
      })
      .then(REST.handler.handleResponse)
      .then(async (data) => {
        toDoList = {
          total: data.total,
          items: await getActionVal(this.props.permissions, token, data.items),
        };
        this.setState({thingsToDo: toDoList});
      })
      .catch((error) => {
        console.error('e', error);
        if (canViewAndContinueSubapplication(this.props.permissions)) {
          REST.dynamicData
            .getSubapplicationsByToken(token)
            .then(REST.handler.handleResponse)
            .then(async (res) => {
              const subAppsData = await getActionVal(this.props.permissions, token, res);
              _.forEach(subAppsData, async (item) => {
                toDoList.items.push(item);
              });
              this.setState({thingsToDo: toDoList});
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
  };

  retrieveUserSavedForLater = async (
    token,
    organizationId,
    limit = 10,
    offset = 0,
    sort = 'entryDate',
    order = 'DESC'
  ) => {
    REST.search
      .getRecipientSavedForLater(token, {
        organizationId: organizationId,
        userId: token.userId,
        limit: limit,
        offset: offset,
        sort: sort,
        order: order,
      })
      .then(REST.handler.handleResponse)
      .then(async (data) => {
        this.setState({
          saveForLater: data,
        });
      })
      .catch(async (error) => {
        console.error(error);
      });
  };

  getUserOrgs = () => {
    const {token} = this.props;
    return REST.user
      .getEntities(token)
      .then((entityResponse) => {
        return forceJsonResponse(entityResponse, FLUX);
      })
      .catch((err) => {
        console.error('Request for user entities failed.');
      })
      .then((entityData) => {
        this.setState({
          entityData: entityData,
        });
        const organizationRequests = _.map(entityData, (entity) =>
          REST.organization.getOrganization(token, entity.entityId)
        );
        return Promise.all(organizationRequests);
      })
      .then((orgResponses) => {
        return Promise.all(_.map(orgResponses, (org) => org.json()));
      })
      .then((orgData) => {
        this.setState({
          allOrgsForUser: orgData,
        });
        return Promise.resolve();
      })
      .catch((err) => {
        console.error('Request for org data failed.');
        return Promise.reject();
      });
  };

  filterByGrantMap = (grantData) => {
    const filterGrantMap = new Map();
    const isGrantPreferred = (item) => {
      return (
        item.entityType === 'grant' &&
        (item.status === 'awardAccepted' ||
          item.status === 'awardOffered' ||
          item.status === 'closeoutInitiated')
      );
    };
    let items = _.includes(this.props.toggles, 'elasticSearch-13734')
      ? grantData.items
      : grantData.flat();
    _.each(items, (item) => {
      if (filterGrantMap.has(item.grantId)) {
        const existingItem = filterGrantMap.get(item.grantId);
        //Grants with status 'awardAccepted' or 'awardOffered' will take precedence otherwise use application
        if (isGrantPreferred(item)) {
          filterGrantMap.set(item.grantId, item);
        } else if (item.entityType === 'application' && !isGrantPreferred(existingItem)) {
          filterGrantMap.set(item.grantId, item);
        }
      } else {
        filterGrantMap.set(item.grantId, item);
      }
    });

    return filterGrantMap;
  };

  getOrganizations = () => {
    const {token, permissions} = this.props;
    const {orgPrograms} = this.state;
    REST.workflow
      .getAllExternalEligibleTasks(
        token,
        ['grantId'],
        _.isEmpty(permissions)
          ? {
              includeAssignedTasks: true,
            }
          : {
              includeAssignedTasks: true,
              candidateGroups: permissions,
            }
      )
      .then((res) => {
        if (res.status === 200) {
          return forceJsonResponse(res, FLUX);
        }
      })
      .then((resJson) => this.setState({tasks: resJson}));

    if (_.includes(this.props.toggles, 'elasticSearch-13734')) {
      return REST.search
        .getMyGrants(this.props.token, this.state.organizationId)
        .then(REST.handler.handleResponse)
        .then((grantData) => {
          const data = Array.from(this.filterByGrantMap(grantData).values());
          this.setState({
            grants: data,
          });
          if (data.length < NUM_ACTIONS_TO_SHOW) {
            this.getApplications();
          } else {
            this.getSubapplications();
            this.setState({
              applications: [],
            });
          }
          return;
        })
        .catch((err) => {
          console.error('Request for grant data failed.');
          this.getSubapplications();
          this.setState({
            applications: [],
            grants: [],
          });
        });
    } else {
      const grantRequests = [];

      _.forEach(orgPrograms, (org) => {
        const [orgId, progId] = org.split('_');
        grantRequests.push(
          REST.dynamicData.getGrantsByOrganization(token, orgId, progId)
        );
      });

      return Promise.all(grantRequests)
        .then((grantResponses) => {
          _.remove(grantResponses, (grant) => !(grant.status === 200));
          return Promise.all(
            _.map(grantResponses, (grantRes) => forceJsonResponse(grantRes, FLUX))
          );
        })
        .then((grantData) => {
          const data = Array.from(this.filterByGrantMap(grantData).values());
          this.setState({
            grants: data,
          });
          this.getSubapplications();
          return;
        })
        .catch((err) => {
          console.error('Request for grant data failed.', err);
          this.getSubapplications();
          this.setState({
            applications: [],
            grants: [],
          });
        });
    }
  };

  getApplications = () => {
    const {orgPrograms} = this.state;
    const {token} = this.props;
    const applicationRequests = [];

    _.forEach(orgPrograms, (org) => {
      const [orgId, progId] = org.split('_');
      applicationRequests.push(
        REST.dynamicData
          .getApplicationsByOrganization(token, orgId, progId)
          .then(REST.handler.handleResponse)
      );
    });

    return Promise.all(applicationRequests)
      .then((resJson) => {
        let apps = _.remove(
          _.flatMap(resJson),
          (app) =>
            app.payload !== undefined &&
            app.payload.applicationSubmittedFor === 'self' &&
            app.status == STATUS_PENDING_SUBMISSION
        );
        return Promise.all(apps);
      })
      .then((apps) => {
        if (_.isEmpty(apps)) {
          this.getSubapplications();
        }
        this.setState({
          applications: apps,
        });
        return;
      })
      .catch((err) => {
        console.error('Request for application data failed.', err);
        this.getSubapplications();
        this.setState({
          applications: [],
        });
      });
  };

  getSubapplications = () => {
    const {token, permissions} = this.props;
    if (canViewAndContinueSubapplication(permissions)) {
      REST.dynamicData
        .getSubapplicationsByToken(token)
        .then(REST.handler.handleResponse)
        .then(async (res) => {
          this.setState({
            subApplications: res,
          });
          if (this.state.saveForLater.failed) {
            this.setState({
              thingsToDo: {
                total: res.length,
                items: await getActionVal(permissions, token, res),
              },
            });
            REST.dynamicData
              .getSavedForUser(this.props.token)
              .then(REST.handler.handleResponse)
              .then((results) => {
                let thingsItems = this.state.thingsToDo.items;
                let newRes = [];
                results.forEach((res) => {
                  let item = _.find(thingsItems, {entityId: res.entityId});
                  if (item) newRes.push(Object.assign(item, res));
                });
                this.setState({saveForLater: {total: newRes.length, items: newRes}});
              })
              .catch((error) => {
                console.error('error');
              });
          }
        })
        .catch((err) => {
          console.error('Request for subapplication data failed.');
          this.setState({
            subApplications: [],
          });
        });
    }
  };

  render() {
    const {enterBy, token, permissions, toggles} = this.props;
    const {
      grants,
      tasks,
      allOrgsForUser,
      applications,
      subApplications,
      saveForLater,
      thingsToDo,
      organizationId,
      orgIds,
      subOrgIds,
    } = this.state;
    const thingsToDoTotal = _.get(thingsToDo, 'items.0.inner_hits.total_count', 0);
    const appDevAndSubToggle = _.includes(toggles, 'appDevAndSub1-1');
    return (
      <React.Fragment>
        {!_.isEmpty(this.state.entityData) &&
          (appDevAndSubToggle ? (
            <MyWorkCard
              token={token}
              permissions={permissions}
              grants={grants}
              applications={applications}
              subApplications={subApplications}
              tasks={tasks}
              organizationId={organizationId}
              orgIds={orgIds}
              subOrgIds={subOrgIds}
              loading={
                grants && applications && subApplications && thingsToDo && saveForLater
              }
              saveForLater={saveForLater}
              thingsToDoTotal={thingsToDoTotal}
              retrieveUserSavedForLater={this.retrieveUserSavedForLater}
              retrieveUserThingsToDo={this.retrieveUserThingsToDo}
              thingsToDo={thingsToDo}
              className="homepage"
            />
          ) : (
            <MyGrantsCard
              token={token}
              permissions={permissions}
              grants={grants}
              applications={applications}
              subApplications={subApplications}
              tasks={tasks}
              loading={grants && applications && subApplications}
            />
          ))}
        {appDevAndSubToggle ? (
          <ApplyNewGrantCardSection userOrgs={allOrgsForUser} className="homepage" />
        ) : (
          <ApplyNewGrantCard userOrgs={allOrgsForUser} />
        )}
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, null)(RecipientActions);
